import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Location } from '@angular/common';

@Component({
    templateUrl: './error-1.component.html'
})

export class Error1Component {
  readonly ERROR_PAGES = {
    "404": {
      code: 404,
      message: " Oops. Trang không tồn tại.",
      subMessage: "Vui lòng thử lại.",
    },
    "403": {
      code: 403,
      message: "Oh! Bạn chưa có quyền thực hiện chức năng này",
      subMessage: "Vui lòng liên hệ với admin hệ thống",
    },
    "500": {
      code: 500,
      message: "Trục trặc hệ thống",
      subMessage: "Vui lòng thử lại hoặc liên hệ với admin hệ thống",
    }
  };

  code = 200;
  constructor(
    private router : Router,
    private activeRoute: ActivatedRoute,
    private _location: Location
  ) {
    this.code = activeRoute.snapshot.data['code']
  }
}
